import {Pipe, PipeTransform} from '@angular/core';
@Pipe ({
   name : 'trim'
})

export class TrimLinePipe implements PipeTransform {

  transform(value : string, numOfChar) : string {
    if (value) {
      if (value.length > numOfChar) {
        return value.slice(0, numOfChar) + '...';
      } else {
        return value;
      }
    }
  }

}
